import React, { Component } from 'react';
import { Container, Card, Spinner, Table, Badge } from 'react-bootstrap';
import { t } from '../../helpers/translation_helper';
import NavBar from '../_partials/NavBar/_NavBar';
import Header from '../_partials/Header/_Header';
import { connect } from 'react-redux';
import axios from 'axios';
import { toast } from 'react-toastify';
import './timetable.css';
import moment from 'moment';
import { GET } from '../../api';
import { AmericanEarth, CerisePink, SeashellPink, White } from '../../helpers/brand_colors_helper';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobe } from '@fortawesome/free-solid-svg-icons';
const ContrastColor = require('contrast-color');

// API URL
const apiURL = process.env.REACT_APP_API_URL;

/**
 * Timetable Component
 */
class TimetableComplete extends Component {
    // State
    state = {
        refreshing: false,
        timetable: [],
        timetable_period_timings: [],
        weekdays: [
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday',
            'Sunday',
        ],
    };

    /**
     * Component Did Mount
     */
    componentDidMount() {
        this.getCompleteTimetable();
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.selectedChild.child_id !== this.props.selectedChild.child_id || prevProps.selectedChild.class_id !== this.props.selectedChild.class_id) {
            this.getCompleteTimetable()
        }
    }
    /**
     * Get Complete Timetable
     */
    getCompleteTimetable = async () => {
        this.setState({ refreshing: true, timetable: [] })
        const { auth_key, center_id } = this.props.authData.loginData;
        const { agegroup_id, class_theme, class_id } =
            this.props.selectedChild;

        let request_params = {
            center_id,
            agegroup_id,
            class_theme,
            class_id,
            auth_key,
        };

        try {
            const res = await GET('dashboard/get-complete-timetable',
                {
                    params: request_params,
                }
            );
            this.setState({
                timetable: res.data.data,
                timetable_period_timings: res.data.timetable_period_timings,
                refreshing: false
            });
        } catch (err) {
            toast.error('Something went wrong while fetching timetable!');
            // console.log(err);
        }
    };

    /**
     * Render Materials
     * @returns {HTMLElement}
     */
    renderPeriods = () => {
        const { weekdays, timetable } = this.state;
        let weekend_days = this.props.authData.centerData.weekend_days.split(',')

        return weekdays.map((item, index) => {
            // console.log('item', item);
            if (weekend_days.includes(item.toLocaleLowerCase())) {
                return null
            }
            const subjects = timetable[item].map((item, index) => {
                const cc = new ContrastColor({
                    bgColor: item.as_color,
                    threshold: 250,
                });
                const defaultFgColor = cc.contrastColor();
                return (
                    <td>
                        {item.acs_name
                            ? (
                                <span
                                    className='badge'
                                    style={{
                                        textTransform: 'uppercase',
                                        fontSize: '13px',
                                        backgroundColor: item.as_color,
                                        color: defaultFgColor,
                                    }}>
                                    {item.acs_name
                                    }
                                    <br />
                                    <small>({item.class_theme})</small>
                                </span>
                            ) : (
                                t('FREE')
                            )}
                    </td>
                );
            });

            return (
                <tr key={index}>
                    <td>{item}</td>
                    {subjects}
                </tr>
            );
        });
    };

    /**
     * Render Component
     * @returns {HTMLElement}
     */
    render() {
        const { timetable, weekdays, timetable_period_timings } = this.state;
        let weekend_days = this.props.authData.centerData.weekend_days.split(',')

        console.log('timetable', timetable);

        return (
            <div >
                {this.state.refreshing &&
                    <div style={{ height: '120px', flexDirection: 'column', }} className='d-flex justify-content-center align-items-center'>
                        {timetable.length <= 0 && this.state.refreshing ? (
                            <>
                                <span className='mb-1'>
                                    <Spinner animation='grow' variant='dark' />
                                </span>
                                {t('Fetching timetable...')}
                            </>
                        ) : (
                            t('No timetable available!')
                        )}
                    </div>
                }

                {(!this.state.refreshing && timetable.Friday) &&
                    <Table bordered style={{ fontSize: 12 }}>
                        <thead>
                            <tr>
                                <th className='text-center'>{t('Day & Time')}</th>
                                {weekdays.map((item, index) => {
                                    if (weekend_days.includes(item.toLocaleLowerCase())) {
                                        return null
                                    }
                                    return <td style={{ backgroundColor: AmericanEarth, color: White }}>{item}</td>
                                })}
                            </tr>
                        </thead>
                        <tbody>
                            {timetable_period_timings.map((tpt_v, tpt_i) => {
                                return <tr key={tpt_i}>
                                    <td >
                                        <div className='d-flex flex-column align-items-center justify-content-center' style={{ height: 50 }}>
                                            <div>{moment(tpt_v.time_start, "HH:mm:ss").format('HH:mm') + ' - ' + moment(tpt_v.time_end, "HH:mm:ss").format('HH:mm')}</div>
                                            {tpt_v.tp_type_name &&
                                                <div style={{
                                                    borderColor: tpt_v.tp_type_color,
                                                    borderWidth: 1,
                                                    borderStyle: 'solid',
                                                    color: tpt_v.tp_type_color,
                                                    textTransform: 'uppercase',
                                                    borderRadius: 5,
                                                    paddingInline: 4,
                                                    paddingBlock: 2,
                                                    display: 'inline-block'
                                                }}>
                                                    {tpt_v.tp_type_name}
                                                </div>
                                            }
                                        </div>
                                    </td>
                                    {weekdays.map((item, index) => {
                                        if (weekend_days.includes(item.toLocaleLowerCase())) {
                                            return null
                                        }
                                        let findTimetable = timetable[item].find((timetable_v) => timetable_v.tpt_id == tpt_v.tpt_id)
                                        const cc = new ContrastColor({
                                            bgColor: findTimetable.as_color,
                                            threshold: 250,
                                        });
                                        const defaultFgColor = cc.contrastColor();
                                        // 
                                        return <td style={{}}>
                                            <div style={{ flex: 1, backgroundColor: (findTimetable.acs_name) ? 'initial' : SeashellPink }} className='px-2 d-flex flex-column justify-content-center'>
                                                {(!findTimetable.acs_name)
                                                    ? <div className='py-3' style={{ color: CerisePink }}>{t('Free')}</div>
                                                    : <div className='d-flex flex-column p-2' style={{ backgroundColor: findTimetable.as_color, borderColor: findTimetable.as_color, color: defaultFgColor, borderRadius: 5 }}>
                                                        <div style={{ fontSize: 10, color: defaultFgColor }}>{findTimetable.class_theme}</div>
                                                        <div className='d-flex flex-row align-items-center justify-content-between'>
                                                            <div style={{ fontWeight: 'bold' }}>{findTimetable.acs_name}</div>
                                                            {findTimetable.class_online_url !== null && (
                                                                <div onClick={() => window.open(findTimetable.class_online_url, '_blank', 'noopener,noreferrer')} className='cursor-pointer'>
                                                                    <FontAwesomeIcon icon={faGlobe} color={defaultFgColor} />
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </td>
                                    })}
                                </tr>
                            })}
                        </tbody>
                    </Table>
                }
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    authData: state.auth.authData,
    selectedChild: state.selectedChild.data,
    languages: state.language.languages,
    defaultLanguage: state.language.defaultLanguage,
});

export default connect(mapStateToProps, null)(TimetableComplete);
